import 'ui-core/plugins/slide/js/slide';
const slide = UX.slide;
slide.setBackLabel = function () {
    slide.$back.html('<i class="icon-arrow_left" aria-hidden="true"></i>');
    slide.$back.attr('aria-label', 'back');
};

slide.displaySlideHtmlToPage = () => {
    const $content = $('.content.journal-branding');
    const $main = $('main');
    if ($content.length > 0) $content.append(slide.$elements);
    else if ($main.length > 0) $main.append(slide.$elements);
    else $('body').append(slide.$elements);
};

slide.on._nestSlide = function () {
    slide.activeSlide++;
    slide.$contents = slide.$elements.find('.w-slide__content:not([class*="nested--"])');
    slide.$contents.append('<div class="w-slide__content nested--' + slide.activeSlide + '"></div>');
    slide.$contents = $('.nested--' + slide.activeSlide);
};

slide.on._returnDataSlide = function (originalTarget) {
    const returnDataSlideHere = slide.nested || slide.multi ? '.returnNestedDataSlideHere' : '.returnDataSlideHere';
    const $returnDataSlideHere =
        slide.clone === 'self' ? $(returnDataSlideHere) : $(returnDataSlideHere, originalTarget);
    slide.$contents.children().appendTo($returnDataSlideHere.last().parent());
    $returnDataSlideHere.last().remove();
};
